import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';

export default function Login() {
  const [tab,   setTab]   = useState('login');
  const [form,  setForm]  = useState({ name: '', email: '', password: '' });
  const [error, setError] = useState('');
  const [busy,  setBusy]  = useState(false);
  const { login, register } = useAuth();
  const nav = useNavigate();

  const set = k => e => setForm(f => ({ ...f, [k]: e.target.value }));

  const submit = async e => {
    e.preventDefault();
    setBusy(true); setError('');
    try {
      if (tab === 'login') await login(form.email, form.password);
      else                 await register(form.name, form.email, form.password);
      nav('/');
    } catch (err) {
      setError(err.response?.data?.error || 'Something went wrong');
    } finally { setBusy(false); }
  };

  return (
    <div style={{
      minHeight: '100vh', background: 'var(--bg)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      padding: 20,
    }}>
      {/* Background glow */}
      <div style={{
        position: 'fixed', top: '20%', left: '50%', transform: 'translate(-50%,-50%)',
        width: 600, height: 400, background: 'radial-gradient(ellipse, #00d4ff12 0%, transparent 70%)',
        pointerEvents: 'none',
      }} />

      <div style={{ width: '100%', maxWidth: 420 }}>
        {/* Logo */}
        <div style={{ textAlign: 'center', marginBottom: 40 }}>
          <div style={{ fontFamily: "'Space Mono', monospace", fontSize: 32, fontWeight: 700, marginBottom: 8 }}>
            <span style={{ color: 'var(--accent)' }}>AUTO</span>PILOT
          </div>
          <div style={{ color: 'var(--muted)', fontSize: 13 }}>AI-powered sales engine for all 3 companies</div>
          <div style={{ display: 'flex', gap: 8, justifyContent: 'center', marginTop: 14 }}>
            {['Maven Group Global', 'B2techsoftLLC', 'Xolosoft LLC'].map((c, i) => (
              <span key={c} style={{
                fontSize: 10, fontWeight: 600, padding: '3px 8px', borderRadius: 20,
                background: ['#00d4ff18','#7c3aed18','#00e67618'][i],
                color: ['#00d4ff','#7c3aed','#00e676'][i],
                border: `1px solid ${['#00d4ff','#7c3aed','#00e676'][i]}44`,
              }}>{c}</span>
            ))}
          </div>
        </div>

        {/* Card */}
        <div style={{ background: 'var(--card)', border: '1px solid var(--border)', borderRadius: 14, padding: 32 }}>
          {/* Tabs */}
          <div style={{ display: 'flex', background: 'var(--surface)', borderRadius: 8, padding: 4, marginBottom: 24 }}>
            {['login','register'].map(t => (
              <button key={t} onClick={() => setTab(t)} style={{
                flex: 1, background: tab === t ? 'var(--card)' : 'transparent',
                border: tab === t ? '1px solid var(--border)' : '1px solid transparent',
                borderRadius: 6, padding: '8px 0', color: tab === t ? 'var(--text)' : 'var(--muted)',
                fontWeight: 600, fontSize: 13, cursor: 'pointer', textTransform: 'capitalize',
              }}>{t}</button>
            ))}
          </div>

          <form onSubmit={submit}>
            {tab === 'register' && (
              <div style={{ marginBottom: 14 }}>
                <label style={lbl}>Full Name</label>
                <input value={form.name} onChange={set('name')} placeholder="Your name" required style={inp} />
              </div>
            )}
            <div style={{ marginBottom: 14 }}>
              <label style={lbl}>Email</label>
              <input type="email" value={form.email} onChange={set('email')} placeholder="admin@yourcompany.com" required style={inp} />
            </div>
            <div style={{ marginBottom: 20 }}>
              <label style={lbl}>Password</label>
              <input type="password" value={form.password} onChange={set('password')} placeholder="••••••••" required style={inp} />
            </div>

            {error && (
              <div style={{ background: 'var(--red)18', border: '1px solid var(--red)44', borderRadius: 7, padding: '10px 14px', color: 'var(--red)', fontSize: 13, marginBottom: 16 }}>
                {error}
              </div>
            )}

            <button type="submit" disabled={busy} style={{
              width: '100%', padding: '12px 0',
              background: 'linear-gradient(135deg, var(--accent), #7c3aed)',
              border: 'none', borderRadius: 8, color: '#000',
              fontWeight: 800, fontSize: 14, cursor: busy ? 'not-allowed' : 'pointer',
              opacity: busy ? .7 : 1, fontFamily: 'inherit',
            }}>
              {busy ? 'Please wait...' : tab === 'login' ? 'Sign In' : 'Create Account'}
            </button>
          </form>

          <div style={{ marginTop: 20, padding: '14px', background: 'var(--surface)', borderRadius: 8, fontSize: 12, color: 'var(--muted)' }}>
            <strong style={{ color: 'var(--mid)' }}>Default credentials:</strong><br/>
            Email: admin@autopilot.com &nbsp;|&nbsp; Password: Admin@123
          </div>
        </div>
      </div>
    </div>
  );
}

const lbl = { display: 'block', fontSize: 11, color: 'var(--muted)', textTransform: 'uppercase', letterSpacing: .5, marginBottom: 5 };
const inp = { width: '100%', background: 'var(--surface)', border: '1px solid var(--border)', borderRadius: 7, padding: '10px 12px', color: 'var(--text)', fontSize: 13, outline: 'none', fontFamily: 'inherit' };
